/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "refresh",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#666666"
            },
            "st1": {
                "fill": "none",
                "stroke": "#FF0000",
                "strokeMiterlimit": "10"
            },
            "refresh": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "125.8",
            "height": "126"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 125.8 126", className: "refresh", width: this.props.width, height: this.props.height, style: this.props.refresh },
            _react2["default"].createElement("path", { className: "st0", d: "M125.6 8.5c0-2.7-4-4.9-6.5-3.1l-14.4 10.4C99.1 10.9 92.9 7 85.9 4.2 78.9 1.5 71.4 0 63.3 0 57.5 0 52 .7 46.6 2.1c-5.4 1.5-10.3 3.6-15 6.3-4.7 2.7-8.9 6-12.8 9.9-3.9 3.8-7.1 8.1-10 12.7-2.7 4.6-4.9 9.6-6.4 14.9C.9 51.3 0 56.9 0 62.7c0 5.8.7 11.4 2.2 16.8s3.6 10.3 6.2 15.1c2.8 4.7 6 8.9 9.9 12.7 3.8 3.9 8.1 7.2 12.7 10s9.6 4.9 14.9 6.5c5.4 1.5 10.9 2.3 16.8 2.3 7.2 0 13.9-1 20.4-3.3 6.5-2.2 12.4-5.3 17.7-9.4 5.3-4 9.9-8.8 13.8-14.3 3.4-4.8 3.8-5.4 4.7-7.5.5-1.1.8-2.4.8-3.7 0-4.9-4-9-8.9-9-3.3 0-6.2 1.8-7.8 4.4-.4.6-1.1 1.7-2.1 3.4-2.3 3.8-3.8 5.6-6.6 8.4-4.3 4.2-9.1 7.4-14.6 9.7-5.4 2.2-11.2 3.2-17.3 3.2-6 0-11.8-1.2-17.2-3.4-5.5-2.3-10.4-5.6-14.6-9.8-4.2-4.3-7.4-9.2-9.6-14.7-2.3-5.5-3.4-11.3-3.4-17.3 0-6.1 1.2-11.8 3.5-17.2 2.2-5.5 5.6-10.4 9.8-14.5 4.3-4.2 9.2-7.5 14.7-9.7 5.4-2.3 11.3-3.3 17.3-3.3 4.9 0 9.5.8 14.1 2.3 4.4 1.5 8.5 3.7 12.3 6.4l-15 10.7c-2.5 1.8-1.7 6.3.8 7.1l44.5 15c2.5.8 5.6-1.4 5.6-4.1v-47z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/refresh.js